import { render, staticRenderFns } from "./TabWaiting.vue?vue&type=template&id=04507e93&"
import script from "./TabWaiting.vue?vue&type=script&lang=js&"
export * from "./TabWaiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports